// src/reducers/recipes_reducers.js
import {
    FETCH_TOP_RECIPE_EVENT_COUNTS_LOADING,
    FETCH_TOP_RECIPE_EVENT_COUNTS_SUCCESS,
    FETCH_TOP_RECIPE_EVENT_COUNTS_FAIL,
    FETCH_SEARCH_RECIPES_LOADING,
    FETCH_SEARCH_RECIPES_SUCCESS,
    FETCH_SEARCH_RECIPES_FAIL,
    FETCH_LATEST_RECIPES_LOADING,
    FETCH_LATEST_RECIPES_SUCCESS,
    FETCH_LATEST_RECIPES_FAIL,
    FETCH_LATEST_PGRECIPES_LOADING,
    FETCH_LATEST_PGRECIPES_SUCCESS,
    FETCH_LATEST_PGRECIPES_FAIL,
    FETCH_SEARCH_ALLRECIPES_LOADING,
    FETCH_SEARCH_ALLRECIPES_SUCCESS,
     FETCH_SEARCH_ALLRECIPES_FAIL,
} from "../actions/types";

const INITIAL_STATE = {
    // Latest Recipes
    latest_recipes_info: [],
    loading_latest_recipes: false,
    latest_recipes_error: null,

    latest_pgrecipes_info: [],
    loading_latest_pgrecipes: false,
    latest_pgrecipes_error: null,
    //RECIPE TOP COUNTS PAGINATED INFO
    recipe_events_info: [],
    recipe_events_error: null,
    loading_recipe_events_info: false,
    //SEARCH RECIPES WITH COUNTS
    search_recipes_info: [],
    search_recipes_error: null,
    loading_search_recipes: false,
    //SEARCH ALL RECIPES
    search_allrecipes_info: [],
    loading_search_allrecipes: false,
    search_allrecipes_error: null,
};

const recipesReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        // Search All Recipes
        case FETCH_SEARCH_ALLRECIPES_LOADING:
            return {
                ...state,
                loading_search_allrecipes: true,
                search_allrecipes_error: null,
            };

        case FETCH_SEARCH_ALLRECIPES_SUCCESS:
            return {
                ...state,
                loading_search_allrecipes: false,
                search_allrecipes_info: action.payload,
                search_allrecipes_error: null,
            };

        case FETCH_SEARCH_ALLRECIPES_FAIL:
            return {
                ...state,
                loading_search_allrecipes: false,
                search_allrecipes_info: [],
                search_allrecipes_error: action.payload,
            };

        //Latest Recipes
        case FETCH_LATEST_RECIPES_LOADING:
            return { 
                ...state, 
                loading_latest_recipes: true, 
                latest_recipes_error: null 
            };

        case FETCH_LATEST_RECIPES_SUCCESS:
            return {
                ...state,
                loading_latest_recipes: false,
                latest_recipes_info: action.payload,
                latest_recipes_error: null,
            };

        case FETCH_LATEST_RECIPES_FAIL:
            return {
                ...state,
                loading_latest_recipes: false,
                latest_recipes_info: [],
                latest_recipes_error: action.payload,
            };
        
        case FETCH_LATEST_PGRECIPES_LOADING:
            return { 
                ...state, 
                loading_latest_pgrecipes: true, 
                latest_pgrecipes_error: null 
            };

        case FETCH_LATEST_PGRECIPES_SUCCESS:
            return {
                ...state,
                loading_latest_pgrecipes: false,
                latest_pgrecipes_info: action.payload,
                latest_pgrecipes_error: null,
            };

        case FETCH_LATEST_PGRECIPES_FAIL:
            return {
                ...state,
                loading_latest_pgrecipes: false,
                latest_pgrecipes_info: [],
                latest_pgrecipes_error: action.payload,
            };
        
        //Top Recipes per Events Page
        case FETCH_TOP_RECIPE_EVENT_COUNTS_FAIL:
            return { ...state, 
                recipe_events_info: [], 
                recipe_events_error: action.payload, 
                loading_recipe_events_info: false 
            };

        case FETCH_TOP_RECIPE_EVENT_COUNTS_LOADING:
            return { ...state, loading_recipe_events_info: true };
            
        case FETCH_TOP_RECIPE_EVENT_COUNTS_SUCCESS:
            console.log('Payload in reducer FETCH_TOP_RECIPE_EVENT_COUNTS_SUCCESS:', action.payload);
            return { 
                ...state, 
                recipe_events_info: action.payload,
                recipe_events_error: null, 
                loading_recipe_events_info: false 
            };
        //Search Recipes
        case FETCH_SEARCH_RECIPES_FAIL:
            return { ...state, 
                search_recipes_info: [], 
                search_recipes_error: action.payload, 
                loading_search_recipes: false 
            };

        case FETCH_SEARCH_RECIPES_LOADING:
            return { ...state, loading_search_recipes: true };
            
        case FETCH_SEARCH_RECIPES_SUCCESS:
            console.log('Payload in reducer FETCH_SEARCH_RECIPES_SUCCESS:', action.payload);
            return { 
                ...state, 
                search_recipes_info: action.payload,
                recipe_events_error: null, 
                loading_recipe_events_info: false 
            };
        default:
            return state;
        }
    };
      
export default recipesReducer;